// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_study.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { DeleteStudyReq, DeleteStudyResp, GetStudyViewerDataReq, GetStudyViewerDataResp, UnsetStudyRawMeshViewerReq, UnsetStudyRawMeshViewerResp } from "./svc_study_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.core.StudyService
 */
export const StudyService = {
  typeName: "com.diagnocat.core.StudyService",
  methods: {
    /**
     * Returns viewer bootstrap data for the given study.
     *
     * `Study.RawMeshViewer` may be used by frontend clients to decide that the study
     * should be opened in the raw mesh viewer flow, but it is not a server-side
     * precondition for this method. Backend implementations should validate study
     * existence and access permissions, not the `Study.RawMeshViewer` flag.
     *
     * @generated from rpc com.diagnocat.core.StudyService.GetStudyViewerData
     */
    getStudyViewerData: {
      name: "GetStudyViewerData",
      I: GetStudyViewerDataReq,
      O: GetStudyViewerDataResp,
      kind: MethodKind.Unary,
    },
    /**
     * Clear `Study.RawMeshViewer` by setting it to `false`.
     *
     * Permission: `StudyPermissions.CanDelete`
     *
     * Removes Raw STL opening for an existing study. Initial `true` is expected to
     * be set during the study creation/upload flow.
     *
     * @generated from rpc com.diagnocat.core.StudyService.UnsetStudyRawMeshViewer
     */
    unsetStudyRawMeshViewer: {
      name: "UnsetStudyRawMeshViewer",
      I: UnsetStudyRawMeshViewerReq,
      O: UnsetStudyRawMeshViewerResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.StudyService.DeleteStudy
     */
    deleteStudy: {
      name: "DeleteStudy",
      I: DeleteStudyReq,
      O: DeleteStudyResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

